(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-liquid"] && !Shopify.designMode) return;
  try {
    
  const initializeOweCollectionCarousels = (scope = document) => {
    scope.querySelectorAll('[data-owe-carousel]').forEach((carousel) => {
      if (carousel.dataset.oweCarouselReady === 'true') return;

      const viewport = carousel.querySelector('[data-owe-carousel-viewport]');
      const previous = carousel.querySelector('[data-owe-carousel-previous]');
      const next = carousel.querySelector('[data-owe-carousel-next]');

      if (!viewport || !previous || !next) return;

      const updateControls = () => {
        const maximumScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        previous.disabled = viewport.scrollLeft <= 2;
        next.disabled = viewport.scrollLeft >= maximumScroll - 2;
      };

      const move = (direction) => {
        viewport.scrollBy({ left: direction * viewport.clientWidth * 0.85, behavior: 'smooth' });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      viewport.addEventListener('scroll', updateControls, { passive: true });
      new ResizeObserver(updateControls).observe(viewport);
      carousel.dataset.oweCarouselReady = 'true';
      updateControls();
    });
  };

  initializeOweCollectionCarousels();
  document.addEventListener('DOMContentLoaded', () => initializeOweCollectionCarousels());
  document.addEventListener('shopify:section:load', (event) => initializeOweCollectionCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
